import OutOfHomeBuys from "./OutOfHomeBuys";

export default OutOfHomeBuys;
